// removed by extract-text-webpack-plugin
module.exports = {"videoBg":"_3mSEF6NUkO-JpEWILmeFYf","video":"N0EneBamOdzBDy8jlx3Wr","videoWrapper":"_3XJ7oERh35Zl36Egcku9Lu","fixed":"_1u5LDgVvDQ1UiPmJ7fDD2m","hasGradient":"_1c3UqafTS21ER954d2HMrD"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Video/Video.module.scss
// module id = 815
// module chunks = 0